<template>
  <div class="ProjectView ProjectViewContacts" v-if="p && p.uuid">
    <div style="position:fixed;left:0mm;right:0;" class="onlyprint noprint">
      <h1 style="padding:0 12px;padding-bottom:24px">
        <div style="width: calc(33.33% + 6px);float:left;">scalene</div>
        <div style="width: 100%;padding-left: 24px;">
          {{ p.name }} - Contacts
        </div>
      </h1>
    </div>
    <table style="width: 100%;">
      <thead style="width: 100%; height: 12.5mm;">
        <tr style="height: 12.5mm!important">
          <td style="height: 7.5mm!important">&nbsp;</td>
        </tr>
      </thead>
      <tbody>
        <div class="columns is-multiline TangledColumns" style="display: block">
          <div class="column is-full Head">
            <div class="columns">
              <div class="column is-one-third TangledColumns-head">Qualité</div>
              <div class="column is-one-third TangledColumns-head">
                Entreprises
              </div>
              <div class="column is-one-third TangledColumns-head">
                Contacts
              </div>
            </div>
          </div>
          <div class="column is-full Role" v-for="role in m" :key="role.id">
            <div class="columns is-multiline">
              <div class="column is-one-third">
                <h3 class="Role__name">{{ role.name }}</h3>
              </div>
              <div class="column is-two-thirds">
                <div class="columns is-multiline" style="position: relative">
                  <div
                    class="column is-full Partner"
                    v-for="partner in role.partners"
                    :key="partner.uuid"
                  >
                    <div class="columns">
                      <div class="column is-half">
                        <ul>
                          <li class="Partner__name">
                            <router-link
                              :to="`/partners/view/${partner.uuid}`"
                              >{{ partner.name }}</router-link
                            >
                          </li>
                          <li class="Partner__address">
                            {{ partner.address }}
                          </li>
                          <li class="Partner__telephone">
                            {{ formatPhone(partner.telephone) }}
                          </li>
                          <li class="Partner__email">{{ partner.email }}</li>
                        </ul>
                      </div>
                      <div class="column is-half">
                        <div class="columns is-multiline">
                          <div
                            v-for="contact in partner.contacts"
                            :key="contact.uuid"
                            class="column is-full Contact"
                            :class="contact.slug"
                          >
                            <ul>
                              <li class="Contact__name">
                                <router-link
                                  :to="`/contacts/view/${contact.uuid}`"
                                  >{{ contact.first_name }}
                                  {{ contact.last_name }}</router-link
                                >
                              </li>
                              <li class="Contact__tel">
                                {{ formatPhone(contact.telephone) }}
                              </li>
                              <li class="Contact__mail">{{ contact.email }}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tbody>
      <tfoot></tfoot>
    </table>

    <div class="buttons noprint">
      <button class="button" @click="downloadExcel">
        <i class="fa fa-download"></i>&nbsp;Télécharger en .xlsx pour Excel
      </button>
      <button class="button" @click="print">
        <i class="fa fa-print"></i>&nbsp; Imprimer le tableau
      </button>
    </div>
  </div>
</template>

<script>
import { types as t, additions as a } from "../../store/actions/projects";
import {
  morphInterlocuteursToTableView,
  displayPhoneNumber,
  cleanPhoneNumber
} from "../../util/func";
import { client } from "../../api";

export default {
  name: "ProjectViewContacts",
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      p: {},
      style_trick: null
    };
  },
  computed: {
    m() {
      return morphInterlocuteursToTableView(
        this.p.interlocuteurs,
        this.p.interlocuteurs_d
      );
    }
  },
  methods: {
    formatPhone: n => displayPhoneNumber(cleanPhoneNumber(n)),
    print() {
      window.print();
    },
    async downloadExcel() {
      client()
        .get("/contacts/excel/" + this.p.id, { responseType: "blob" })
        .then(response => {
          const pdf = response.data;
          const a = document.createElement("a");
          const blob = new Blob([pdf], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = `contacts-${this.p.slug}.xlsx`;
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  async mounted() {
    this.p = await this.$store.dispatch(t.GET_PROJECT_BY_UUID, {
      uuid: this.uuid,
      appends: [a.CONTACTS, a.INTERLOCUTEURS_D]
    });
    this.style_trick = document.createElement("style");
    this.style_trick.innerText = `@media print { html *, body *, html, * { overflow-x: visible!important; }} @page { margin: 1cm; }`;
    document.body.appendChild(this.style_trick);
  },
  async beforeDestroy() {
    if (this.style_trick) {
      document.body.removeChild(this.style_trick);
    }
  }
};
</script>

<style lang="scss">
@mixin borderExceptLast() {
  &::after {
    content: "";
    width: 100%;
    display: block;
    background: black;
    height: 1px;
    position: relative;
    top: 12px;
    @media print {
      border: none;
      background: white;
      box-shadow: 0 0.5px black;
    }
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
}

.ProjectViewContacts {
  thead td {
    font-weight: 700;
  }
  h1 {
    @include borderExceptLast();
    flex: 0 0 100%;
    &:last-child {
      &::after {
        display: block !important;
      }
    }
  }
  @media print {
    color: black;

    a,
    li {
      color: black;
      text-decoration: none;
      display: block;
    }
  }
  .TangledColumns {
    margin: 2em 0;
    @media print {
      margin: 0;
    }
    &-head {
      font-weight: 700;
    }
    .Role {
      @include borderExceptLast();
      &__name {
        font-weight: 700;
      }
    }

    .Head {
      @include borderExceptLast();
    }

    .Partner {
      @include borderExceptLast();
      li {
        font-size: 0.75em;
        padding-left: 0.5em;
      }
      li.Partner__name {
        font-weight: 700;
        font-size: 1em;
        padding-left: 0;
      }
    }

    .Contact {
      @include borderExceptLast();
      li {
        font-size: 0.75em;
        padding-left: 0.5em;
      }
      li.Contact__name {
        font-weight: 700;
        font-size: 1em;
        padding-left: 0;
      }
    }
  }
}

.ProjectViewContacts {
  * {
    overflow-x: visible;
    font-size: 10px !important;
    line-height: 15px !important;
    font-weight: 400 !important;
    font-family: Synthese;
  }
  @media print {
    h1 {
      padding-left: 0.75em;
    }
    .Contact.non-communique {
      display: none;
    }
    .Partner,
    .Role {
      position: relative;
      page-break-inside: avoid !important;
      -webkit-region-break-inside: avoid !important;
      display: block !important;
      break-inside: avoid !important;
    }
    .Partner li,
    .Contact li {
      padding-left: 0 !important;
    }
    .Partner__email,
    .Contact__mail {
      overflow-wrap: break-word;
      word-wrap: break-word;

      -ms-word-break: break-all;
      /* This is the dangerous one in WebKit, as it breaks things wherever */
      word-break: break-all;
      /* Instead use this non-standard one: */
      word-break: break-word;

      /* Adds a hyphen where the word breaks, if supported (No Blink) */
      -ms-hyphens: auto;
      -moz-hyphens: auto;
      -webkit-hyphens: auto;
      hyphens: auto;
      line-height: 1;
    }
  }
}
</style>
